// Repair/RepairDashboardGraphs.tsx
import React from "react";
import { RepairBarGraph } from "./GraphComponents/RepairBarGraph";
import RepairDonutChart from "./GraphComponents/RepairDonutChart";
import { useSelector } from "react-redux";
import type { RootState } from "../../../../../store/store";

const RepairDashboardGraphs: React.FC = () => {
  const statusFilter = useSelector((state: RootState) => state.filter.statusFilter);

  return (
    <>
      {statusFilter === "all" && (
        <div className="flex justify-between lg:flex-row flex-col min-w-full max-w-full gap-2">
          <div className="xl:w-1/2 lg:w-1/2 w-full gap-3 border-2 border-gray-300 rounded-lg p-5 max-w-screen">
            <div className="flex gap-4 justify-between">
              <div>
                <span className="font-semibold">Month Wise Repair Status</span>
              </div>
            </div>
            <RepairBarGraph className="w-full h-64 mt-5" type="bar" />
          </div>

          <div className="xl:w-1/2 lg:w-1/2 w-full border-2 border-gray-300 rounded-lg p-5 max-w-screen">
            <RepairDonutChart />
          </div>
        </div>
      )}
    </>
  );
};

export default RepairDashboardGraphs;
